import PropTypes from 'prop-types';
import React, { Component } from 'react';

import CCIVRPayment from 'components/checkout/caap/payment/CCIVRPayment';
import styles from 'styles/components/checkout/caap/payment/paymentlist/confirmCardButton.scss';

export class ConfirmCardButton extends Component {
  state = { showModal: false };

  onCloseModalOverlayClick = () => {
    this.setState({ showModal: false });
  }

  showModal = () => {
    this.setState({ showModal: true });
  }

  render() {
    const {
      confirmCardButtonId,
      isChecked,
      isExpired,
      isFetchingCheckoutData,
      onCardValidate,
      paymentInstrumentId,
      selectedPaymentNeedsConfirmation,
      showCCIVRPayment
    } = this.props;
    const { testId } = this.context;
    const { showModal } = this.state;
    const clickHandler = showCCIVRPayment ? this.showModal : e => onCardValidate(e, paymentInstrumentId);

    if (selectedPaymentNeedsConfirmation && isChecked && !isExpired) {
      return (
        <div className={styles.confirmCardBtnContainer}>
          <button
            className={styles.checkoutPrimaryButton}
            data-test-id={testId('confirmCCButton')}
            disabled={isFetchingCheckoutData}
            id={confirmCardButtonId}
            onClick={clickHandler}
            type="button">
            Confirm Card
          </button>
          { !!showModal && <CCIVRPayment onCloseModalOverlayClick={this.onCloseModalOverlayClick} endpoint="validateCardForm" title="Confirm Card" />}
        </div>
      );
    }

    return null;
  }
}

ConfirmCardButton.contextTypes = {
  testId: PropTypes.func
};

export default ConfirmCardButton;
